export default {
  topbarVisible: state => state.topbarVisible,
  sidebarVisible: state => state.sidebarVisible,
  token: state => state.token,
  username: state => state.user.name,
  spname: state => state.user.sp_name,
  sp_id: state => state.user.sp_id,
  sp_contactor: state => state.user.sp_contactor,
  avatar: state => state.user.avatar,
  inviteinfo_is_loading: state => state.invite.loading,
  inviteinfo_qrcode: state => state.invite.qrcode,
  inviteinfo_reportqrcodes: state => state.invite.reportqrcodes,
  inviteinfo_url: state => state.invite.url,
  inviteinfo_reporturls: state => state.invite.reporturls,
  inviteinfo_home_page_url: state => state.invite.home_page_url,
  inviteinfo_is_apply_sub_domain: state => state.invite.is_apply_sub_domain,
  inviteinfo_sub_domain_name: state => state.invite.sub_domain_name,
  inviteinfo_sub_domain_status: state => state.invite.sub_domain_status,
  inviteinfo_is_apply_own_domain: state => state.invite.is_apply_own_domain,
  inviteinfo_own_domain_name: state => state.invite.own_domain_name,
  inviteinfo_own_domain_status: state => state.invite.own_domain_status,
  info_loading: state => state.info.loading,
  info_saving: state => state.info.saving,
  info_name: state => state.info.name,
  info_contactor: state => state.info.contactor,
  info_contact_phone: state => state.info.contact_phone,
  info_email: state => state.info.email,
  info_address: state => state.info.address,
  info_about_content: state => state.info.about_content,
  info_logo: state => state.info.logo,
  info_bind_sys_code: state => state.info.bind_sys_code,
  info_yhl_team_name: state => state.info.yhl_team_name,
  info_yhl_team_id: state => state.info.yhl_team_id,
  info_yhl_branch_id: state => state.info.yhl_branch_id,
  info_active_edition: state => state.info.active_edition,
  info_expire_date: state => state.info.expire_date,
  info_spec: state => state.info.spec,
  info_login_account: state => state.info.login_account,
  info_left_days: state => state.info.left_days,
  info_use_we_chat_third_party_platform: state => state.info.use_we_chat_third_party_platform,
  wechat_loading: state => state.wechat.loading,
  wechat_saving: state => state.wechat.saving,
  wechat_app_id: state => state.wechat.app_id,
  wechat_app_secret: state => state.wechat.app_secret,
  wechat_encoding_aes_key: state => state.wechat.encoding_aes_key,
  wechat_token: state => state.wechat.token,
  wechat_server_ip: state => state.wechat.server_ip,
  wechat_callback_url: state => state.wechat.callback_url,
  wechat_verified_domain: state => state.wechat.verified_domain,
  wechat_qr_code: state => state.wechat.qr_code,
  wechat_is_empty: state => state.wechat.is_empty,
  wechat_transfer_message_to_kf_system: state => state.transfer_message_to_kf_system,
  form_loading: state => state.form.loading,
  form_saving: state => state.form.saving,
  form_list: state => state.form.list,
  form_total: state => state.form.total,
  shared_form_list: state => state.form.shared_list,
  shared_form_total: state => state.form.shared_total,
  form_df_loading: state => state.form.df_loading,
  form_df: state => state.form.df,
  report_list_loading: state => state.report_list.loading,
  report_list_columns: state => state.report_list.columns,
  report_list_data: state => state.report_list.data,
  report_list_additional_parameters: state => state.report_list.additional_parameters,
  report_list_total: state => state.report_list.total,
  report_report_detail_loading: state => state.report_detail.loading,
  report_report_detail_ticket: state => state.report_detail.ticket,
  report_report_detail_no: state => state.report_detail.no,
  report_report_detail_videos: state => state.report_detail.videos,
  report_report_detail_voices: state => state.report_detail.voices,
  report_report_detail_attachments: state => state.report_detail.attachments,
  report_report_detail_service_ticket: state => state.report_detail.service_ticket,
  report_report_detail_service_ticket_loaded: state => state.report_detail.service_ticket_loaded,
  wechat_menu_loading: state => state.wechat_menu.loading,
  wechat_menu_saving: state => state.wechat_menu.saving,
  wechat_menu_menu: state => state.wechat_menu.menu,
  sub_domain_list_loading: state => state.sub_domain_list.loading,
  sub_domain_list_data: state => state.sub_domain_list.data,
  sub_domain_list_total: state => state.sub_domain_list.total,
  account_info_loading: state => state.account_info.loading,
  account_info_spec: state => state.account_info.spec,
  account_info_can_renew_service: state => state.account_info.can_renew_service,
  account_info_can_upgrade_edition: state => state.account_info.can_upgrade_edition,
  account_info_active_edition: state => state.account_info.active_edition,
  account_info_expire_date: state => state.account_info.expire_date,
  account_info_left_days: state => state.account_info.left_days,
  account_info_list_data: state => state.account_info.list_data,
  account_info_list_total: state => state.account_info.list_total,
  account_info_list_loading: state => state.account_info.list_loading,
  sp_list_loading: state => state.sp_list.loading,
  sp_list_data: state => state.sp_list.data,
  sp_list_total: state => state.sp_list.total,
  setting_loading: state => state.setting.loading,
  setting_saving: state => state.setting.saving,
  setting_setting: state => state.setting.setting,
  report_steps_querying: state => state.report_steps.querying,
  report_steps_steps: state => state.report_steps.steps,
  report_steps_current: state => state.report_steps.current,
  repair_member_list_loading: state => state.repair_member_list.loading,
  repair_member_list_data: state => state.repair_member_list.data,
  repair_member_list_total: state => state.repair_member_list.total,
}



// WEBPACK FOOTER //
// ./src/store/getters.js